import { firstByClass } from 'OK/utils/dom';
import { ajax } from 'OK/utils/vanilla';

/** @type {string} */
var CSS_INVISIBLE = 'invisible';

function activate(infoPanel) {
    var shortClass = infoPanel.getAttribute('data-short-class');
    var shortClassThreshold = infoPanel.getAttribute('data-short-class-threshold');
    var showAll = firstByClass(infoPanel, 'js-expand');
    var hideAll = firstByClass(infoPanel, 'js-collapse');
    var infoCnt = firstByClass(infoPanel, 'js-cnt');
    var map = firstByClass(infoPanel, 'js-map');

    var catalogInfo = firstByClass(infoPanel, 'group-info_selections');
    var catalogInfoClose = firstByClass(infoPanel, 'close-catalog-info');
    var rknInfoLink = firstByClass(infoPanel, 'js-rkn-info');
    if (catalogInfo && catalogInfoClose) {
        var closeLink = infoPanel.getAttribute('data-close-link');
        catalogInfoClose.onclick = function () {
            infoPanel.removeChild(catalogInfo);
            ajax({
                'url': closeLink
            });
        };
    }

    if (showAll && hideAll && infoCnt) {

        var shortHeight = infoCnt.clientHeight;
        infoCnt.classList.remove(shortClass);
        var fullHeight = infoCnt.clientHeight;

        var toggleMap = document.createEvent('HTMLEvents');
        toggleMap.initEvent(infoPanel.getAttribute('data-toggle-map-event'), true, true);

        if (fullHeight - shortHeight > shortClassThreshold || map || rknInfoLink) {
            // если в "компактном" варианте явно не влезает как минимум одна строка, или нужно показать по клику скрытую карту
            infoCnt.classList.add(shortClass);
            showAll.classList.remove(CSS_INVISIBLE);

            showAll.onclick = function () {
                infoCnt.classList.remove(shortClass);
                showAll.classList.add(CSS_INVISIBLE);
                hideAll.classList.remove(CSS_INVISIBLE);
                map && map.dispatchEvent(toggleMap);
                rknInfoLink && rknInfoLink.classList.remove(CSS_INVISIBLE);
            };

            hideAll.onclick = function () {
                infoCnt.classList.add(shortClass);
                hideAll.classList.add(CSS_INVISIBLE);
                showAll.classList.remove(CSS_INVISIBLE);
                map && map.dispatchEvent(toggleMap);
                rknInfoLink && rknInfoLink.classList.add(CSS_INVISIBLE);
            };
        }
    }
}

export default { activate };

export { activate };
